import { GridApi, GridOptions } from '@ag-grid-community/core';
import {
  INITIAL_GRID_OPTION_KEYS,
  ManagedGridOptions,
} from '@ag-grid-community/core/dist/esm/es6/propertyKeys';

export function syncGridOptions(gridAPI: GridApi, gridOptions: Partial<GridOptions>) {
  Object.entries(gridOptions).forEach(([key, value]) => {
    if (INITIAL_GRID_OPTION_KEYS[key as keyof typeof INITIAL_GRID_OPTION_KEYS]) {
      return;
    }

    gridAPI.setGridOption(key as keyof ManagedGridOptions, value);
  });
}
